/**
 *  @class
 *  @function MovBar
 */

if (!customElements.get('mov-bar')) {
  class MovBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      let amountText = this.querySelector('.free-shipping--text span');
      let total = parseInt(this.dataset.cartTotal, 10);
      let minimum = Math.round(parseInt(this.dataset.minimum, 10) * (Shopify.currency.rate || 1));

      if (total < minimum) {
        let percentage = total / minimum;

        if (amountText) {
          let remaining = minimum - total;
          let format = window.theme.settings.money_with_currency_format || "${{amount}}";
          amountText.innerHTML = formatMoney(remaining, format);
        }

        this.style.display = '';
        this.style.setProperty('--percentage', percentage);
        } else {
        this.style.display = 'none';
        }
      
    }
  }

  customElements.define('mov-bar', MovBar);
}